import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import type { IStrapiImage } from '~/types/strapiImage';

interface IPwaInstallModalTab {
  title: string;
  image: IStrapiImage;
  list: { text: string }[];
}

export const useStorePwaInstallModal = defineStore('pwaInstallModal', {
  state: () => ({
    title: '',
    firstTabBlock: [] as IPwaInstallModalTab[],
    secondTabBlock: [] as IPwaInstallModalTab[],
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadPwaInstallModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'firstTabBlock',
          'firstTabBlock.image',
          'firstTabBlock.list',
          'secondTabBlock',
          'secondTabBlock.image',
          'secondTabBlock.list',
        ]);
        this.requestPromise = strapi()
          .get('pwa-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
